import * as React from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';
import { useLoggedInUser } from '@xing-com/crate-hooks-use-logged-in-user';

type OptionalNWTrackingParams = {
  event: string;
  element?: string;
  element_state?: string;
  itemUrn?: string;
  itemActorUrn?: string;
  moduleTitle?: string;
  position?: number;
  verticalPosition?: number;
  modulePosition?: number;
  positionInModule?: number;
  element_detail?: string;
};

type InteractionTrackingParams = {
  trackAction?: string;
  PropActionOrigin?: string;
  pageName?: string;
  event?: string;
  EventProfileEditingSave?: string;
};

type UseInsightsTrackingProps = InteractionTrackingParams;

type UseInsightsTrackingReturn = {
  trackWithNWT: (extraData: OptionalNWTrackingParams) => void;
  trackInteraction: (
    overrideTrackAction?: string,
    extraData?: Omit<InteractionTrackingParams, 'trackAction'>
  ) => void;
};

export const useInsightsTracking = (
  _props: UseInsightsTrackingProps = {}
): UseInsightsTrackingReturn => {
  const { track } = useTracking();
  const { id: userId } = useLoggedInUser() ?? {};

  const trackWithNWT = React.useCallback<
    UseInsightsTrackingReturn['trackWithNWT']
  >(
    (extraData) => {
      track({
        application: 'wbm',
        eventSchema: 'extended',
        sentBy: 'disco',
        page: 'discover/update',
        type: 'nwt',
        userId,
        ...extraData,
      });
    },
    [track, userId]
  );

  const trackInteraction = React.useCallback<
    UseInsightsTrackingReturn['trackInteraction']
  >((_overrideTrackAction, _extraData) => {}, []);

  return {
    trackWithNWT,
    trackInteraction,
  };
};
